/**
 * Status line for a vector source whose registration fell back to the
 * extents stretch (no layout labels matched).
 *
 * The fallback is "approximate" for a DXF (content extents ≠ page edges) but
 * EXACT for a PDF extraction, whose manifest extents ARE the page box (R3-D).
 * Saying "approximate" there read as a defect on the first production smoke
 * (owner, 2026-09-27), so the wording follows the source.
 */
import type { OverlayDxf } from '../stores/projectStore';

export function isPdfVectorSource(dxf: Pick<OverlayDxf, 'srcKey' | 'pageIndex'>): boolean {
  return /\.pdf$/i.test(dxf.srcKey ?? '') || dxf.pageIndex != null;
}

export const DXF_FALLBACK_TEXT =
  'Approximate placement — no layout labels matched, lines are stretched onto the plan sheet';

export const PDF_FALLBACK_TEXT =
  'Placed by page geometry — the lines sit exactly where they are on the sheet. '
  + 'No layout labels matched yet; import a layout and press Re-align to bind them.';

export function fallbackPlacementText(dxf: Pick<OverlayDxf, 'srcKey' | 'pageIndex'>): string {
  return isPdfVectorSource(dxf) ? PDF_FALLBACK_TEXT : DXF_FALLBACK_TEXT;
}
